<template>
  <div class="content">
    <div class="hint" v-html="contact_title"></div>
    <div class="info">
      <div class="i_item">
        <i class="el-icon-user"></i>
        <el-input v-model="user_name" placeholder="Please enter your name"></el-input>
      </div>
      <div class="i_item">
        <i class="el-icon-chat-line-round"></i>
        <el-input v-model="title" placeholder="Please enter your question"></el-input>
      </div>
      <div class="i_item">
        <i class="el-icon-message"></i>
        <el-input v-model="email" @blur="validateEmail" placeholder="Please enter your email address"></el-input>
        <p class="red" v-if="emailError">{{ emailError }}</p>
      </div>
      <el-button type="primary" @click="add()">submit</el-button>
    </div>
  </div>
</template>

<script>
import { adminCustomerInfoAdd,adminConfigInfo } from "@/request/api";
export default {
  name: "HomeView",
  data() {
    return {
      user_name: "",
      title: "",
      email: "",
      emailError: "",
      contact_title: ''

    };
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      adminConfigInfo().then(res => {
        console.log(res);
        this.contact_title = res.results[0].contact_title;
        // this.text = res.results[0].about_body;
        // this.logo_image = res.results[0].logo;
        // this.src = res.results[0].home_page;
        // this.src = res.results[0].about_page;
      });
    },
    validateEmail() {
      console.log(this.email);
      // const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\.com$/; 
      const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; 
      if (!pattern.test(this.email)) {
        this.emailError = "Please enter a valid email address.";
      } else {
        this.emailError = ""; // 清除错误信息
      }
    },
    add() {
      adminCustomerInfoAdd({
        user_name: this.user_name,
        title: this.title,
        email: this.email
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.$message({
            showClose: true,
            message: "Submit successfully",
            type: "success"
          });
          this.user_name = "";
          this.title = "";
          this.email = "";
        } else {
          this.$message({
            showClose: true,
            message: res.errMsg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.content {
  text-align: left;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px solid #c2c2c2;
  border-radius: 5px;
  margin-left: 100px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader-icon2 {
  font-size: 28px;
  color: #8c939d;
  width: 500px;
  height: 300px;
  line-height: 300px;
  text-align: center;
  border: 1px solid #c2c2c2;
  border-radius: 5px;
  margin-left: 100px;
}
.avatar2 {
  width: 500px;
  height: 300px;
  display: block;
}
.title {
  text-align: left;
  font-size: 24px;
  margin: 30px 0 20px 50px;
}
.el-input {
  width: 300px;
  /* margin-left: 100px; */
}
.mb-20 {
  margin-bottom: 20px !important;
}
.ml-100 {
  margin-left: 100px;
}
.ml-20 {
  margin-left: 20px;
}
.hint {
  width: 80%;
  text-align: center;
  margin: 50px auto;
}
.info {
  margin: 50px auto;
  width: 500px;
  /* background-color: pink; */
  text-align: center;
}
.i_item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  /* background-color: pink; */
  position: relative;
}
.i_item i {
  font-size: 30px;
  margin-right: 10px;
}
.red {
  color: #f56c6c;
  position: absolute;
  bottom: -20px;
}
.el-button {
  margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue